import { getCollaboratorInitials } from '@modules/dashboard/helpers';
import {
  Avatar,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { DashboardViewFragment, UserInfoViewFragment } from 'generated/graphql';
import { truncate } from 'lodash';
import { DashboardRemoveCollaboratorButton } from '../DashboardRemoveCollaboratorButton';

interface DashboardShareCollaboratorListItemProps {
  user: UserInfoViewFragment;
  isCreator?: boolean;
  dashboard: Pick<
    DashboardViewFragment,
    'id' | 'viewToken' | 'editToken' | 'version'
  >;
}

const MAX_NAME_LENGTH_TO_SHOW = 60;

export const DashboardShareCollaboratorListItem = ({
  user,
  isCreator,
  dashboard,
}: DashboardShareCollaboratorListItemProps) => {
  return (
    <ListItem disablePadding key={user.id}>
      <ListItemButton>
        <ListItemIcon>
          <Avatar>{getCollaboratorInitials(user)}</Avatar>
        </ListItemIcon>
        <ListItemText>
          <Stack
            direction="row"
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="body1">
              {truncate(`${user.firstName} ${user.lastName}`, {
                length: MAX_NAME_LENGTH_TO_SHOW,
              })}
            </Typography>
            {isCreator ? (
              <Typography variant="caption" color="text.disabled">
                Dashboard Creator
              </Typography>
            ) : (
              <DashboardRemoveCollaboratorButton
                dashboard={dashboard}
                userToRemove={user}
              />
            )}
          </Stack>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );
};
